import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section, Tags} from 'components/UIKit';
import * as locales from '../../locales';
import {Tag} from '../../types';
import styles from './ListingTags.scss';

export interface ListingTagsProps {
  tags: Tag[];
}

function ListingTagsComponent({tags, i18n}: ListingTagsProps & WithI18nProps) {
  return (
    <Section
      fullWidth
      spacing="small"
      heading={i18n.translate('tags')}
      headingProps={{type: 'h5', component: 'h2'}}
    >
      <Tags tags={tags} className={styles.Tags} />
    </Section>
  );
}

export const ListingTags = withI18n({
  id: 'Listing',
  fallback: locales.en,
})(ListingTagsComponent);

export default ListingTags;
